import { useEffect, useState } from 'react';
import { useGameStore } from '../../core/store';
import { skillBoards } from '../../data/skillBoards';
import { LockerObjectiveTip } from '../locker/LockerObjectiveTip';
import './tunnel-objective-tip.css';

const TIP_HOLD_MS = 7800;

const TITLE = 'FIRST SKILL AHEAD';
const LINE_DESKTOP =
  'Move forward and walk the boards — collect AI & LLM, then the rest.';
const LINE_MOBILE = 'Move forward and collect skills on the boards.';

type Props = {
  compact?: boolean;
  /** Only show after the how-to guide is dismissed (Got it). */
  ready?: boolean;
};

/**
 * Tunnel start objective — same typewriter + popup tip sound as locker.
 * Appears only after the controls guide "Got it" flow.
 */
export function TunnelObjectiveTip({ compact = false, ready = false }: Props) {
  const walking = useGameStore((s) => s.tunnelWalking);
  const unlocked = useGameStore((s) => s.unlockedSkills);
  const runnerZ = useGameStore((s) => s.runnerZ);
  const [visible, setVisible] = useState(false);
  const [startZ, setStartZ] = useState<number | null>(null);

  const firstUnlocked = unlocked.includes(skillBoards[0]?.id ?? 'ai');

  useEffect(() => {
    if (!walking || !ready || firstUnlocked) {
      setVisible(false);
      setStartZ(null);
      return;
    }

    setStartZ(useGameStore.getState().runnerZ);
    setVisible(true);
    const hide = window.setTimeout(() => setVisible(false), TIP_HOLD_MS);

    return () => window.clearTimeout(hide);
  }, [walking, ready, firstUnlocked]);

  useEffect(() => {
    if (!visible || startZ == null) return;
    if (runnerZ > startZ + 1.2) {
      const t = window.setTimeout(() => setVisible(false), 1600);
      return () => window.clearTimeout(t);
    }
  }, [visible, runnerZ, startZ]);

  return (
    <LockerObjectiveTip
      className={`tunnel-objective-tip${compact ? ' tunnel-objective-tip--compact hud-tip--mobile' : ''}`}
      visible={visible}
      tab="OBJECTIVE"
      title={TITLE}
      line={compact ? LINE_MOBILE : LINE_DESKTOP}
    />
  );
}
